<template>
  <div class="ctc-wrap">
    <div class="ctc-padding">
      <main class="trade-main">
        <section class="item-symbol">
          <header class="search-header">
            <span
              v-for="(item, index) in symbolList"
              v-if="item.baseSymbol !== $t('trade_ctc.header.self')"
              @click="coinListChange(index)"
              :class="{ 'choice-tab': coinFilter.listIndex === index }"
              >
              <template v-if="item.baseSymbol === 'USDT'">{{ item.baseSymbol.replace("T", "") }}</template>
              <template v-else>{{ item.baseSymbol }}</template>
              </span
            >
          </header>
          <div class="mt12 bj-w">
            <!-- 去除浏览器自动键入用户名和密码 -->
            <el-input style="position: fixed; bottom: -9999px"></el-input>
            <el-input
              type="password"
              style="position: fixed; bottom: -9999px"
            ></el-input>

            <el-input
              class="change-coin-input"
              :placeholder="$t('trade_ctc.search.placeholder')"
              v-model="coinFilter.keyword"
            >
              <i
                slot="suffix"
                class="iconfont iconsousuo"
                @click="getFilterCoinTable"
              ></i>
            </el-input>

            <div class="change-table" ref="change_table">
              <el-table
                v-if="symbolList.length > 0"
                :data="coinTable"
                :height="symbolHeight"
                style="width: 100%"
                @row-click="rowClick"
              >
                <el-table-column
                  :label="$t('trade_ctc.search.coin_type')"
                  width="60"
                >
                  <template slot-scope="scope">
                    <!-- <template v-if="user.username">
                      <img
                        v-if="scope.row.collect"
                        @click.stop="updateSymbol(scope.row, 2)"
                        style="
                          width: 14px;
                          vertical-align: text-top;
                          margin-right: 2px;
                        "
                        src="../../assets/img/icon_star_green.png"
                      />
                      <img
                        v-else
                        @click.stop="updateSymbol(scope.row, 1)"
                        style="
                          width: 14px;
                          vertical-align: text-top;
                          margin-right: 2px;
                        "
                        src="../../assets/img/icon_star_white.png"
                      />
                    </template> -->
                    <label>{{ scope.row.s.split("/")[0] }}</label>
                    <!-- /{{ scope.row.s.split("/")[1] }} -->
                  </template>
                </el-table-column>
                <el-table-column
                  prop="c"
                  :label="$t('trade_ctc.search.price')"
                  width="100"
                  :sort-method="getSort_c"
                  sortable
                >
                  <template slot-scope="scope">
                    <label>{{ getFloorNum(scope.row.c, getSymbolPrecision(scope.row.s, 'price')) + " " + scope.row.s.split("/")[1].replace("T", "") }} </label>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('trade_ctc.search.range')"
                  :sort-method="getSort_p"
                  sortable
                  align="center"
                >
                  <template slot-scope="scope">
                    <label v-if="scope.row.p >= 0" style="color: #42cb83"
                      >+{{
                        getFloorNumAndComplemented(scope.row.p * 100, 2)
                      }}%</label
                    >
                    <label v-else style="color: #f04c66"
                      >{{
                        getFloorNumAndComplemented(scope.row.p * 100, 2)
                      }}%</label
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </section>
        <section class="item-m">
          <header class="market-header">
            <div class="header-items">
              <div class="item-coin">
                <div class="coin-wrap">
                  <img
                    v-if="buyAndSell_init.icon"
                    :src="buyAndSell_init.icon"
                    style="width: 24px"
                  />
                  <img
                    v-else
                    src="../../assets/img/icon_coin_default.png"
                    style="width: 24px"
                  />
                  <span style="color: #333333;font-weight: bold;">{{
                    buyAndSell_init.symbol.split("/")[0]
                  }}</span>
                </div>
              </div>
              <div class="item" v-if="marketData !== null">
                <p>{{ $t("trade_ctc.header.price") }}</p>
                <div>
                  {{ getFloorNum(marketData.c, buyAndSell_init.price_precision) }}<span style="margin-left: 4px">{{ buyAndSell_init.symbol.split("/")[1].replace("T", "") }}</span>
                  <label style="margin-left: 10px; color: #55688b">{{ changeValueByRate() }} </label>
                </div>
              </div>
              <div class="item" v-if="marketData !== null">
                <p>{{ $t("trade_ctc.header.change") }}</p>
                <div v-if="marketData.p >= 0" style="color: #3ec197">
                  +{{ getFloorNumAndComplemented(marketData.p * 100, 2) }}%
                </div>
                <div v-else style="color: #f04c66">
                  {{ getFloorNumAndComplemented(marketData.p * 100, 2) }}%
                </div>
              </div>
              <div class="item" v-if="marketData !== null">
                <p>{{ $t("trade_ctc.header.high") }}</p>
                <div>
                  {{ getFloorNum(marketData.h, buyAndSell_init.price_precision) }}<span style="margin-left: 4px">{{ buyAndSell_init.symbol.split("/")[1].replace("T", "") }}</span>
                </div>
              </div>
              <div class="item" v-if="marketData !== null">
                <p>{{ $t("trade_ctc.header.low") }}</p>
                <div>
                  {{ getFloorNum(marketData.l, buyAndSell_init.price_precision) }}<span style="margin-left: 4px">{{ buyAndSell_init.symbol.split("/")[1].replace("T", "") }}</span>
                </div>
              </div>
              <div class="item" v-if="marketData !== null">
                <p>{{ $t("trade_ctc.header.volume") }}</p>
                <div>
                  {{ getFloorNum(marketData.v, buyAndSell_init.coin_precision) }}<span style="margin-left: 4px">{{ buyAndSell_init.symbol.split("/")[0] }}</span>
                </div>
              </div>
            </div>
            <span class="fullscreen-icon" @click="toggleKlineFullscreen">
              <i v-if="!isKlineFullscreen" class="el-icon-full-screen"/>
              <i v-else class="el-icon-crop" />
            </span>
          </header>
          <div class="tab-head">
            <div :class="{ sel: tableShow === 1 }" @click="tableShow = 1">
              {{ $t("user_assets.web_record.transaction") }}
            </div>
            <div :class="{ sel: tableShow === 2 }" @click="tableShow = 2">
              {{ $t("user_assets.web_record.info") }}
            </div>
          </div>
          <template v-if="tableShow === 1">
            <div class="kline-wrap">
              <div v-if="buyAndSell_init.countdown > 0" class="not-start">
                {{ getLeftTime }}
                <span style="font-size: 16px">{{
                  $t("trade_ctc.trans_start")
                }}</span>
              </div>
              <v-super-kline
                v-if="precisionLoaded"
                :key="klineSymbol + '-' + buyAndSell_init.price_precision"
                :symbol="klineSymbol"
                :price_precision="buyAndSell_init.price_precision"
                :coin_precision="buyAndSell_init.coin_precision"
              ></v-super-kline>
            </div>
            <div class="buy-sell-box-wrap">
              <header class="header clear">
                <div class="left">
                  <span
                    :class="{ choice: tradeBoxType === 'limit' }"
                    @click="tradeBoxType = 'limit'"
                  >
                    {{ $t("trade_ctc.buyAndSell.limit_delegation") }}
                  </span>
                </div>
              </header>
              <div class="buy-box-wrap">
                <v-buy-sell
                  v-show="tradeBoxType === 'limit'"
                  :detail="buyAndSell_init"
                ></v-buy-sell>
              </div>
            </div>
          </template>
          <DetailInfo v-else :coinType="buyAndSell_init.symbol" />
        </section>
        <section class="item-l">
          <header class="header">
            <span @click="buyAndSell_showType = 'all'">
              <img
                v-if="buyAndSell_showType === 'all'"
                src="@/assets/img/images/icon/icon-tab1-s.png"
              />
              <img v-else src="@/assets/img/images/icon/icon-tab1.png" />
            </span>
            <span @click="buyAndSell_showType = 'buy'">
              <img
                v-if="buyAndSell_showType === 'buy'"
                src="@/assets/img/images/icon/icon-tab2-s.png"
              />
              <img v-else src="@/assets/img/images/icon/icon-tab2.png" />
            </span>
            <span @click="buyAndSell_showType = 'sell'">
              <img
                v-if="buyAndSell_showType === 'sell'"
                src="@/assets/img/images/icon/icon-tab3-s.png"
              />
              <img v-else src="@/assets/img/images/icon/icon-tab3.png" />
            </span>
          </header>
          <aside class="th">
            <div class="price-item">
              {{ $t("trade_ctc.buyAndSell.price") }}({{ getMoneyType }})
            </div>
            <div class="volume-item">
              {{ $t("trade_ctc.buyAndSell.volume") }}({{ getCoin }})
            </div>
            <div class="money-item">
              {{ $t("trade_ctc.buyAndSell.money") }}({{ getMoneyType }})
            </div>
          </aside>
          <div class="show-window" v-if="marketData !== null">
            <div class="all-wrap" v-show="buyAndSell_showType === 'all'">
              {{ getFloorNum(marketData.c, buyAndSell_init.price_precision) }} ≈
              {{ changeValueByRate() }} 
              <ul class="sell-ul">
                <li
                  v-for="item in buyAndSellData.sell"
                  @click="getPrice(item[0])"
                  style="cursor: pointer"
                >
                  <div>{{ getFloorNum(item[0], buyAndSell_init.price_precision) }}</div>
                  <div>{{ getFloorNum(item[1], buyAndSell_init.coin_precision) }}</div>
                  <div>{{ getFloorNum(item[0] * item[1], buyAndSell_init.price_precision) }}</div>
                </li>
              </ul>
              <ul class="buy-ul">
                <li
                  v-for="item in buyAndSellData.buy"
                  @click="getPrice(item[0])"
                  style="cursor: pointer"
                >
                  <div>{{ getFloorNum(item[0], buyAndSell_init.price_precision) }}</div>
                  <div>{{ getFloorNum(item[1], buyAndSell_init.coin_precision) }}</div>
                  <div>{{ getFloorNum(item[0] * item[1], buyAndSell_init.price_precision) }}</div>
                </li>
              </ul>
            </div>
            <div v-show="buyAndSell_showType === 'buy'" class="buy-wrap">
              <ul class="buy-ul">
                <li
                  v-for="item in buyAndSellData.buy"
                  @click="getPrice(item[0])"
                  style="cursor: pointer"
                >
                  <div>{{ getFloorNum(item[0], buyAndSell_init.price_precision) }}</div>
                  <div>{{ getFloorNum(item[1], buyAndSell_init.coin_precision) }}</div>
                  <div>{{ getFloorNum(item[0] * item[1], buyAndSell_init.price_precision) }}</div>
                </li>
              </ul>
            </div>
            <div v-show="buyAndSell_showType === 'sell'" class="sell-wrap">
              <ul class="sell-ul">
                <li
                  v-for="item in buyAndSellData.sell"
                  @click="getPrice(item[0])"
                  style="cursor: pointer"
                >
                  <div>{{ getFloorNum(item[0], buyAndSell_init.price_precision) }}</div>
                  <div>{{ getFloorNum(item[1], buyAndSell_init.coin_precision) }}</div>
                  <div>{{ getFloorNum(item[0] * item[1], buyAndSell_init.price_precision) }}</div>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section class="item-r">
          <header class="header">
            {{ $t("trade_ctc.deal.title") }}
          </header>
          <div class="table-header">
            <ul class="clear">
              <li class="left">{{ $t("trade_ctc.deal.price") }}</li>
              <li class="left">{{ $t("trade_ctc.deal.amount") }}</li>
              <li class="left">{{ $t("trade_ctc.deal.time") }}</li>
            </ul>
          </div>
          <div class="table-con">
            <ul>
              <li v-for="item in dealNow">
                <span
                  class="table-li1"
                  :class="{ red: item.direction === 'SELL' }"
                  >{{ getFloorNum(item.price, buyAndSell_init.price_precision) }}</span
                >
                <span class="table-li2">{{ getFloorNum(item.amount, buyAndSell_init.coin_precision) }}</span>
                <span class="table-li3">{{
                  dateFormatter(new Date(item.time), "hh:mm:ss")
                }}</span>
              </li>
            </ul>
          </div>
        </section>
      </main>

      <div class="box-1">
        <div class="tab-box">
          <div
            :class="{ sel: currTab === 'current' }"
            @click="tabChange('current')"
          >
            {{ $t("trade_ctc.buyAndSell.current_delegation") }}
          </div>
          <div
            :class="{ sel: currTab === 'history' }"
            @click="tabChange('history')"
          >
            {{ $t("trade_ctc.buyAndSell.history_delegation") }}
          </div>
        </div>
        <div class="delegation-div">
          <div class="delegation-wrap" v-if="currTab === 'current'">
            <el-table
              :height="tableHeight"
              :data="current_delegation"
              style="width: 100%"
            >
              <el-table-column
                min-width="150"
                prop="time"
                :label="$t('trade_ctc.delegationTable.time')"
              >
                <template slot-scope="scope">
                  {{
                    dateFormatter(new Date(scope.row.time), "yyyy-MM-dd hh:mm")
                  }}
                </template>
              </el-table-column>
              <el-table-column
                min-width="80"
                :label="$t('trade_ctc.delegationTable.pay_type')"
              >
                <template slot-scope="scope">
                  <label
                    v-if="scope.row.directionStr === 'BUY'"
                    style="color: #42cb83"
                    >{{ $t("trade_ctc.delegationTable.buy") }}</label
                  >
                  <label
                    v-else-if="scope.row.directionStr === 'SELL'"
                    style="color: #f04c66"
                    >{{ $t("trade_ctc.delegationTable.sell") }}</label
                  >
                </template>
              </el-table-column>
              <el-table-column
                min-width="160"
                :label="
                  $t('trade_ctc.delegationTable.amount') +
                  '/' +
                  $t('trade_ctc.delegationTable.beenDone') +
                  '(' +
                  getCoin +
                  ')'
                "
              >
                <template slot-scope="scope">
                  <label>{{ getFloorNum(scope.row.amount, buyAndSell_init.coin_precision) }}</label
                  >/{{ getFloorNum(scope.row.tradedAmount, buyAndSell_init.coin_precision) }}
                </template>
              </el-table-column>
              <el-table-column
                :label="
                  $t('trade_ctc.delegationTable.price') +
                  '/' +
                  $t('trade_ctc.delegationTable.averagePrice') +
                  '(' +
                  getMoneyType +
                  ')'
                "
                min-width="170"
              >
                <template slot-scope="scope">
                  <label>{{ getFloorNum(scope.row.price, buyAndSell_init.price_precision) }}</label
                  >/{{ getFloorNum(scope.row.tradedAvgPrice, buyAndSell_init.price_precision) }}
                </template>
              </el-table-column>
              <el-table-column
                min-width="150"
                :label="$t('trade_ctc.delegationTable.money')"
              >
                <template slot-scope="scope">
                  {{ scope.row.turnover > 0 ? getFloorNum(scope.row.turnover, buyAndSell_init.price_precision) : "---" }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('trade_ctc.delegationTable.status')">
                <template slot-scope="scope">
                  <label
                    v-if="scope.row.statusStr === 'TRADING'"
                    :class="{ 'color-white': scope.row.turnover > 0 }"
                  >
                    {{
                      scope.row.turnover > 0
                        ? $t("trade_ctc.delegationTable.trading")
                        : $t("trade_ctc.delegationTable.un_trade")
                    }}
                  </label>
                  <label v-if="scope.row.statusStr === 'CANCELING'">
                    {{ $t("trade_ctc.delegationTable.canceling") }}
                  </label>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('trade_ctc.delegationTable.operation')"
              >
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.statusStr === 'TRADING'"
                    class="cancel-btn"
                    @click="orderCancel(scope.row)"
                    >{{ $t("trade_ctc.delegationTable.cancel") }}</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="delegation-wrap" v-if="currTab === 'history'">
            <el-table
              :height="tableHeight"
              :data="history_delegation"
              style="width: 100%"
            >
              <el-table-column
                min-width="150"
                prop="time"
                :label="$t('trade_ctc.delegationTable.time')"
              >
                <template slot-scope="scope">
                  {{
                    dateFormatter(new Date(scope.row.time), "yyyy-MM-dd hh:mm")
                  }}
                </template>
              </el-table-column>
              <el-table-column
                min-width="80"
                :label="$t('trade_ctc.delegationTable.pay_type')"
              >
                <template slot-scope="scope">
                  <label
                    v-if="scope.row.directionStr === 'BUY'"
                    style="color: #42cb83"
                    >{{ $t("trade_ctc.delegationTable.buy") }}</label
                  >
                  <label
                    v-else-if="scope.row.directionStr === 'SELL'"
                    style="color: #f04c66"
                    >{{ $t("trade_ctc.delegationTable.sell") }}</label
                  >
                </template>
              </el-table-column>
              <el-table-column
                min-width="160"
                :label="
                  $t('trade_ctc.delegationTable.amount') +
                  '/' +
                  $t('trade_ctc.delegationTable.beenDone') +
                  '(' +
                  getCoin +
                  ')'
                "
              >
                <template slot-scope="scope">
                  <label>{{ getFloorNum(scope.row.amount, buyAndSell_init.coin_precision) }}</label
                  >/{{ getFloorNum(scope.row.tradedAmount, buyAndSell_init.coin_precision) }}
                </template>
              </el-table-column>
              <el-table-column
                min-width="170"
                :label="
                  $t('trade_ctc.delegationTable.price') +
                  '/' +
                  $t('trade_ctc.delegationTable.averagePrice') +
                  '(' +
                  getMoneyType +
                  ')'
                "
              >
                <template slot-scope="scope">
                  <label>{{ getFloorNum(scope.row.price, buyAndSell_init.price_precision) }}</label
                  >/{{ getFloorNum(scope.row.tradedAvgPrice, buyAndSell_init.price_precision) }}
                </template>
              </el-table-column>
              <el-table-column
                min-width="150"
                :label="$t('trade_ctc.delegationTable.money')"
              >
                <template slot-scope="scope">
                  {{ scope.row.turnover > 0 ? getFloorNum(scope.row.turnover, buyAndSell_init.price_precision) : "---" }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('trade_ctc.delegationTable.status')">
                <template slot-scope="scope">
                  <label v-if="scope.row.statusStr === 'COMPLETED'">
                    {{ $t("trade_ctc.delegationTable.completed") }}
                  </label>
                  <label v-else-if="scope.row.turnover > 0">
                    {{ $t("trade_ctc.delegationTable.part_completed") }}
                  </label>
                  <label v-else>
                    {{ $t("trade_ctc.delegationTable.canceled") }}
                  </label>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('trade_ctc.delegationTable.operation')"
              >
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.turnover <= 0"
                    class="cancel-btn"
                    @click="deleteHistory(scope.row)"
                    >{{ $t("trade_ctc.delegationTable.deleteRecord") }}</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <v-footer></v-footer>

    <div v-if="isKlineFullscreen" class="fullscreen-kline-overlay" @click.self="toggleKlineFullscreen">
      <div class="fullscreen-header">
        <div class="header-left">
          <div class="coin-wrap" @click="toggleDrawer" style="cursor: pointer;">
            <img v-if="buyAndSell_init.icon" :src="buyAndSell_init.icon" />
            <img v-else src="../../assets/img/icon_coin_default.png" />
            <span>{{ buyAndSell_init.symbol.split("/")[0] }}</span>
          </div>
          <div class="market-info" v-if="marketData !== null">
            <div class="info-item">
              <p>{{ $t("trade_ctc.header.price") }}</p>
              <div>{{ getFloorNum(marketData.c, buyAndSell_init.price_precision) }} {{ buyAndSell_init.symbol.split("/")[1].replace("T", "") }}</div>
            </div>
            <div class="info-item">
              <p>{{ $t("trade_ctc.header.change") }}</p>
              <div :style="marketData.p >= 0 ? 'color: #3ec197' : 'color: #f04c66'">{{ marketData.p >= 0 ? '+' : '' }}{{ getFloorNumAndComplemented(marketData.p * 100, 2) }}%</div>
            </div>
            <div class="info-item">
              <p>{{ $t("trade_ctc.header.high") }}</p>
              <div>{{ getFloorNum(marketData.h, buyAndSell_init.price_precision) }} {{ buyAndSell_init.symbol.split("/")[1].replace("T", "") }}</div>
            </div>
            <div class="info-item">
              <p>{{ $t("trade_ctc.header.low") }}</p>
              <div>{{ getFloorNum(marketData.l, buyAndSell_init.price_precision) }} {{ buyAndSell_init.symbol.split("/")[1].replace("T", "") }}</div>
            </div>
            <div class="info-item">
              <p>{{ $t("trade_ctc.header.volume") }}</p>
              <div>{{ getFloorNum(marketData.v, buyAndSell_init.coin_precision) }} {{ buyAndSell_init.symbol.split("/")[0] }}</div>
            </div>
          </div>
        </div>
        <span class="fullscreen-icon" @click="toggleKlineFullscreen">
          <i class="el-icon-close" />
        </span>
      </div>
      <div class="fullscreen-chart">
        <v-super-kline
          v-if="precisionLoaded"
          :key="'fullscreen-' + klineSymbol + '-' + buyAndSell_init.price_precision"
          :symbol="klineSymbol"
          :price_precision="buyAndSell_init.price_precision"
          :coin_precision="buyAndSell_init.coin_precision"
        ></v-super-kline>
      </div>
    </div>

    <el-drawer
      title=""
      :visible.sync="isDrawerOpen"
      direction="ltr"
      :size="260"
      :show-close="false"
      :before-close="toggleDrawer"
      class="symbol-drawer"
      :z-index="10000"
    >
      <section class="item-symbol">
        <header class="search-header">
          <span
            v-for="(item, index) in symbolList"
            v-if="item.baseSymbol !== $t('trade_ctc.header.self')"
            @click="coinListChange(index)"
            :class="{ 'choice-tab': coinFilter.listIndex === index }"
            >
            <template v-if="item.baseSymbol === 'USDT'">{{ item.baseSymbol.replace("T", "") }}</template>
            <template v-else>{{ item.baseSymbol }}</template>
            </span
          >
        </header>
        <div class="mt12 bj-w">
          <el-input style="position: fixed; bottom: -9999px"></el-input>
          <el-input
            type="password"
            style="position: fixed; bottom: -9999px"
          ></el-input>

          <el-input
            class="change-coin-input"
            :placeholder="$t('trade_ctc.search.placeholder')"
            v-model="coinFilter.keyword"
          >
            <i
              slot="suffix"
              class="iconfont iconsousuo"
              @click="getFilterCoinTable"
            ></i>
          </el-input>

          <div class="change-table" ref="change_table">
            <el-table
              v-if="symbolList.length > 0"
              :data="coinTable"
              :height="symbolHeight"
              style="width: 100%"
              @row-click="rowClick"
            >
              <el-table-column
                :label="$t('trade_ctc.search.coin_type')"
                width="60"
              >
                <template slot-scope="scope">
                  <label>{{ scope.row.s.split("/")[0] }}</label>
                </template>
              </el-table-column>
              <el-table-column
                prop="c"
                :label="$t('trade_ctc.search.price')"
                width="100"
                :sort-method="getSort_c"
                sortable
              >
                <template slot-scope="scope">
                  <label>{{ getFloorNum(scope.row.c, getSymbolPrecision(scope.row.s, 'price')) + " " + scope.row.s.split("/")[1].replace("T", "") }} </label>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('trade_ctc.search.range')"
                :sort-method="getSort_p"
                sortable
                align="center"
              >
                <template slot-scope="scope">
                  <label v-if="scope.row.p >= 0" style="color: #42cb83"
                    >+{{
                      getFloorNumAndComplemented(scope.row.p * 100, 2)
                    }}%</label
                  >
                  <label v-else style="color: #f04c66"
                    >{{
                      getFloorNumAndComplemented(scope.row.p * 100, 2)
                    }}%</label
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </section>
    </el-drawer>
  </div>
</template>

<script>
import DetailInfo from "./components/DetailInfo.vue";
import VSuperKline from "../../components/Kline/VSuperKline";
import VBuySell from "../../components/BuyOrSell/VBuyOrSell";
import VFooter from "../../components/footer/VFooter";
import { mapState } from "vuex";
import bus from "../../assets/js/bus";
import { Icon } from "element-ui";

export default {
  components: {
    VFooter,
    VBuySell,
    DetailInfo,
    VSuperKline,
  },
  name: "c-t-c",
  inject: ["reload"],
  data() {
    return {
      tableShow: 1,
      currTab: "current",
      symbolHeight: 786,
      tableHeight: 285,
      isKlineFullscreen: false,
      isDrawerOpen: false,
      socket: null,
      allSymbolData: null,
      marketData: null,
      allMarketData: null,
      klineSymbol: "",
      buyAndSell_showType: "all",
      updateFlag: true,
      cnyRate: 6,
      buyAndSell_init: {
        icon: "",
        countdown: "", //距离开启交易的毫秒数
        init_price: 0, //初始单价
        symbol: "RWA/USDT", //交易对
        money_total: 0.0, //可用资金
        coin_total: 0, //用户拥有的此币数量,
        price_precision: 4, //单价精度
        coin_precision: 4, //币的精度
        rate: 6, //汇率
      },
      precisionLoaded: false, //精度数据是否已加载
      allPrecisionData: [], //所有交易对的精度数据
      buyAndSellData: {
        buy: [],
        sell: [],
      },
      tradeBoxType: "limit",
      currentFilter: {
        needPage: 0, //不分页
        priceType: "limit",
        symbol: "",
      },
      historyFilter: {
        needPage: 1, //分页
        pageNumber: 1,
        pageSize: 50,
        priceType: "limit",
        symbol: "",
      },
      current_delegation: [],
      history_delegation: [],
      dealNow: [],
      coinFilter: {
        keyword: "",
        listIndex: 1,
      },
      originalSymbol: [], //一次调用接口获取的原始交易对信息
      coinTable: [], //当前显示的交易对
      symbolList: [], //所有交易对
      pingTime: 0, //服务端心跳时间戳
      socketTimer: null,
      tableDataTimer: null,
      tableDataTimer2: null,
      transTimer: null,
    };
  },
  created() {
    let that = this;
    let symbol = this.$route.query.symbol
      ? this.$route.query.symbol
      : "RWA/USDT";
    if (this.$route.query.symbolListIndex) {
      this.coinFilter.listIndex = parseInt(this.$route.query.symbolListIndex);
    } else if (!this.user.username) {
      this.coinFilter.listIndex = 1;
    }
    this.klineSymbol =
      symbol.split("/")[0].toLowerCase() +
      "_" +
      symbol.split("/")[1].toLowerCase();
    this.buyAndSell_init.symbol = symbol;
    this.currentFilter.symbol = symbol;
    this.historyFilter.symbol = symbol;
    this.getRate();
    this.getPrecision();
    if (this.user.username && window.localStorage.getItem("jwt-token")) {
      this.getUserAsset();
      this.getCurrentDelegation(); //获取当前委托列表
      this.getHistoryDelegation(); //获取历史委托
    }
    bus.$on("getUserAssets", function () {
      that.getUserAsset();
    });
    bus.$on("getDelegation", function () {
      that.getCurrentDelegation(); //获取当前委托列表
      that.getHistoryDelegation(); //获取历史委托
    });
    this.getWebsocket();
    this.webSocketWatch();
    this.getTableDataTimer();
  },
  mounted() {
    // //console.log(document.getElementsByClassName('buy-sell-box-wrap')[0].clientHeight)
    // this.tableHeight = document.getElementsByClassName('buy-sell-box-wrap')[0].clientHeight - 18
    // console.log(this.$refs.change_table.clientHeight)
    if (this.$refs.change_table) {
      this.symbolHeight = this.$refs.change_table.clientHeight;
    }
  },
  destroyed() {
    document.title = "RWA.ltd";
    if (this.socket) {
      this.socket.close();
    }
    clearInterval(this.socketTimer);
    this.socketTimer = null;
    clearInterval(this.tableDataTimer);
    this.tableDataTimer = null;
    clearInterval(this.tableDataTimer2);
    this.tableDataTimer2 = null;
    clearInterval(this.transTimer);
    this.transTimer = null;
  },
  methods: {
    toggleKlineFullscreen() {
      this.isKlineFullscreen = !this.isKlineFullscreen;
    },
    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
    },
	timstampToDate(timestamp) {
		// 创建Date对象
		const date = new Date(timestamp);
		
		// 方法1：手动拼接成「年-月-日 时:分:秒」（推荐，格式可控）
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，补0
		const day = String(date.getDate()).padStart(2, '0');
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
		const seconds = String(date.getSeconds()).padStart(2, '0');
		
		const formatTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		console.log(formatTime); // 输出：2026-08-16 15:26:08
		
		// 方法2：使用toLocaleString（自动适配本地格式，兼容性好）
		console.log(date.toLocaleString('zh-CN')); // 输出：2026/8/16 15:26:08
		
		return date.toLocaleString('zh-CN');
	},
    tabChange(val) {
      this.currTab = val;
      this.getTableDataTimer();
    },
    //获取CNY对USDT汇率
    getRate() {
      this.$axios.post("/HomePage/coinCurrencyRate", {}).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          res.data.data.forEach((item) => {
            if (item.legalCurrency === "USDT") {
              this.cnyRate = this.buyAndSell_init.rate = item.rate;
            }
          });
        }
      });
    },
    //距离交易开启的倒计时
    getTransTimer() {
      let that = this;
      this.transTimer = setInterval(function () {
        if (that.buyAndSell_init.countdown < 0) {
          clearInterval(that.transTimer);
          that.reload();
        } else {
          that.buyAndSell_init.countdown =
            that.buyAndSell_init.countdown - 1000;
        }
      }, 1000);
    },
    //定时查询是否有撤销中订单，刷新数据
    getTableDataTimer() {
      let that = this;
      //撤单的查询定时器
      this.tableDataTimer = setInterval(function () {
        that.current_delegation.forEach((value) => {
          if (value.statusStr === "CANCELING") {
            that.getCurrentDelegation(); //获取当前委托列表
            that.getHistoryDelegation(); //获取历史委托
            that.getUserAsset(); //获取用户资产
          }
        });
      }, 1500);
      //正常的订单查询定时器
      this.tableDataTimer2 = setInterval(function () {
        if (that.user.username && window.localStorage.getItem("jwt-token")) {
          that.getCurrentDelegation(); //获取当前委托列表
          that.getHistoryDelegation(); //获取历史委托
          that.getUserAsset(); //获取用户资产
        }
      }, 5000);
    },
	changeValueByRate() {
		if(this.buyAndSell_init.symbol.split("/")[1] === "USDT") {
			return "HKD " + this.getFloorNum(this.marketData.c * this.buyAndSell_init.rate, this.buyAndSell_init.price_precision)
		} else {
			return "USD " + this.getFloorNum(this.marketData.c / this.buyAndSell_init.rate, this.buyAndSell_init.price_precision)
		}
	},
    getPrice(price) {
      this.buyAndSell_init.init_price = price;
    },
    //获取币种精度
    getPrecision() {
      let that = this;
      this.$axios
        .post("/TradePage/allPrecision", {})
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            that.allPrecisionData = res.data.data;
            that.updatePrecision(that.buyAndSell_init.symbol);
            that.precisionLoaded = true;
          }
        });
    },
    //根据symbol更新精度
    updatePrecision(symbol) {
      let that = this;
      let precisionData = that.allPrecisionData.find(item => item.symbol === symbol);
      if (precisionData) {
        that.$set(that.buyAndSell_init, 'price_precision', precisionData.baseCoinScale);
        that.$set(that.buyAndSell_init, 'coin_precision', precisionData.coinScale);
      }
    },
    //根据symbol获取精度
    getSymbolPrecision(symbol, type) {
      let precisionData = this.allPrecisionData.find(item => item.symbol === symbol);
      if (precisionData) {
        if (type === 'price') {
          return precisionData.baseCoinScale;
        } else if (type === 'coin') {
          return precisionData.coinScale;
        }
      }
      return type === 'price' ? this.buyAndSell_init.price_precision : this.buyAndSell_init.coin_precision;
    },
    //交易对列表改变
    coinListChange(index) {
      this.coinFilter.listIndex = index;
      this.coinTable = [];
      if (this.symbolList[index]) {
        this.coinTable = this.symbolList[index].coinSymbols;
      }
    },
    //搜索交易对列表
    getFilterCoinTable() {
      if (this.symbolList[this.coinFilter.listIndex]) {
        if (this.coinFilter.keyword) {
          this.coinTable = this.symbolList[
            this.coinFilter.listIndex
          ].coinSymbols.filter((item) => {
            if (
              item.s
                .split("/")[0]
                .indexOf(this.coinFilter.keyword.toUpperCase()) >= 0
            ) {
              return true;
            } else {
              return false;
            }
          });
        } else {
          this.coinTable =
            this.symbolList[this.coinFilter.listIndex].coinSymbols;
        }
      }
    },
    rowClick(row, event, column) {
      this.buyAndSell_init.symbol = row.s;
      this.klineSymbol =
        row.s.split("/")[0].toLowerCase() +
        "_" +
        row.s.split("/")[1].toLowerCase();
      this.currentFilter.symbol = row.s;
      this.historyFilter.symbol = row.s;
      this.buyAndSell_init.symbol = row.s;
      this.buyAndSell_init.init_price = parseFloat(row.c);
      this.buyAndSell_init.icon = row.icon;
      this.dealNow = [];
      this.updatePrecision(row.s);
      if (this.user.username && window.localStorage.getItem("jwt-token")) {
        this.getCurrentDelegation();
        this.getHistoryDelegation();
        // this.getUserAsset();
      }
      this.socket.close();
      this.getWebsocket();
      this.$router.replace({
        path: "/ctc",
        query: { symbol: row.s, symbolListIndex: this.coinFilter.listIndex },
      });
      // this.reload();
    },
    updateSymbol(row, status) {
      if (this.updateFlag) {
        this.updateFlag = false;
        this.$axios
          .post("/user/updateSymbol", { symbol: row.s, status: status })
          .then((res) => {
            if (res.data.code === this.errorCode.ok) {
              this.coinListChange(this.coinFilter.listIndex);
              this.$store.commit("updateSymbol", {
                symbol: row.s,
                status: status,
              });
              row.collect = !row.collect;
              //更新自选列表
              if (status === 1) {
                this.symbolList[0].coinSymbols.push(row); //加入自选列表
              } else {
                this.symbolList[0].coinSymbols.forEach((value, index) => {
                  if (value.s === row.s) {
                    this.symbolList[0].coinSymbols.splice(index, 1); //从自选列表删除
                  }
                });
              }
            }
            this.updateFlag = true;
          });
      }
    },
    getAllCoinMarket(symbolList) {
      let that = this;
      this.symbolList = this.deepCopy(symbolList);
      //数组头部插入空自选列表
      this.symbolList.unshift({
        baseSymbol: that.$t("trade_ctc.header.self"),
        coinSymbols: [],
      });
      for (let i = 1; i < that.symbolList.length; i++) {
        let baseSymbol = that.symbolList[i].baseSymbol;
        let coinList = that.symbolList[i].coinSymbols;
        let newCoinList = [];
        for (let j = 0; j < coinList.length; j++) {
          //创建新的交易对行情数组
          let symbol = coinList[j].coinSymbol + "/" + baseSymbol;
          if (that.allMarketData.hasOwnProperty(symbol)) {
            that.user.symbol.forEach((value) => {
              //根据用户信息中的搜藏分辨交易对是否收藏
              if (value === symbol) {
                that.$set(that.allMarketData[symbol], "collect", true); //已收藏
                that.symbolList[0].coinSymbols.push(that.allMarketData[symbol]); //加入自选列表
              }
            });
            if (!that.allMarketData[symbol].hasOwnProperty("collect")) {
              that.$set(that.allMarketData[symbol], "collect", false); //未收藏
            }
            that.$set(that.allMarketData[symbol], "icon", coinList[j].icon); //加入图标icon地址
            newCoinList.push(that.allMarketData[symbol]);
          }
        }
        that.symbolList[i].coinSymbols = newCoinList;
      }
      //console.log(that.symbolList)
    },
    //获取所有交易对
    getSymbolList() {
      this.$axios.post("/exchangeCoin/getAll", {}).then((res) => {
        //console.log(res.data);
        let that = this;
        if (res.data.code === this.errorCode.ok) {
          this.originalSymbol = res.data.data.symbolArray;
          //icon图标初始化
          for (let i = 0; i < this.originalSymbol.length; i++) {
            if (
              that.originalSymbol[i].baseSymbol ===
              that.buyAndSell_init.symbol.split("/")[1]
            ) {
              that.originalSymbol[i].coinSymbols.forEach((value) => {
                if (
                  value.coinSymbol === that.buyAndSell_init.symbol.split("/")[0]
                ) {
                  that.buyAndSell_init.icon = value.icon;
                  that.buyAndSell_init.countdown = value.countdown;
                  if (that.buyAndSell_init.countdown > 0) {
                    that.getTransTimer();
                  }
                }
              });
            }
          }
          this.getAllCoinMarket(this.originalSymbol);
          this.coinListChange(this.coinFilter.listIndex);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    //websocket心跳间隔计时器
    webSocketWatch() {
      let that = this;
      this.socketTimer = setInterval(function () {
        that.pingTime = that.pingTime + 5;
      }, 5000);
    },
    //websocket (depth,tick,trade)
    getWebsocket() {
      let that = this;
      let arr = this.buyAndSell_init.symbol.split("/");
      let ws_symbol = arr[0] + "_" + arr[1];
      let Socket = new WebSocket(
        this.$axios.defaults.baseWS +
          "/ws/client/h5/" +
          (this.user.userId ? this.user.userId : 99000000),
      );
      this.socket = Socket;
      let depthStr = "market." + ws_symbol + ".depth";
      let tradeStr = "market." + ws_symbol + ".trade";
      let tickerStr = "market.ticker";
      // let orderStr = "market.order.myorders";
      Socket.onopen = function () {
        console.log("WebSocket开启");
        Socket.send(
          JSON.stringify({
            sub: depthStr,
            symbol: that.buyAndSell_init.symbol,
          }),
        ); //订阅盘口
        Socket.send(
          JSON.stringify({
            sub: tradeStr,
            symbol: that.buyAndSell_init.symbol,
          }),
        ); //订阅最新交易
        Socket.send(JSON.stringify({ sub: tickerStr })); //订阅ticker(交易对行情)
      };
      Socket.onmessage = function (res) {
        console.log("CTC.vue on websocket response " + res.data);
        let retData = JSON.parse(res.data);
        if (retData.ping) {
          //心跳返回 记录心跳时间并且返回pong
          that.pingTime = 0;
          Socket.send(JSON.stringify({ pong: retData.ping }));
        } else if (retData.sub === depthStr) {
          //盘口数据
          if (retData.data && retData.data.asks) {
            retData.data.asks.reverse(); //卖数组倒序
          }
          if (retData.data && retData.data.hasOwnProperty("bids")) {
            that.buyAndSellData.buy = retData.data.bids;
          }
          if (retData.data && retData.data.hasOwnProperty("asks")) {
            that.buyAndSellData.sell = retData.data.asks;
          }
        } else if (retData.sub === tradeStr) {
          //最近交易数据
          that.dealNow = retData.data.reverse().concat(that.dealNow);
          if (that.dealNow.length > 50) {
            //如果长度大于50，则删除多余长度数组
            that.dealNow.splice(-1, that.dealNow.length - 50);
          }
        } else if (retData.sub === tickerStr) {
          //ticker数据
          if (retData.data.hasOwnProperty(that.buyAndSell_init.symbol)) {
            that.marketData = retData.data[that.buyAndSell_init.symbol];
            let title = `${that.marketData.c} ${that.marketData.s}`;
            document.title = title;
          }
          if (!that.allMarketData) {
            that.allMarketData = retData.data;
            //初始化买卖组件价格

            if (that.allMarketData[that.buyAndSell_init.symbol]) {
              that.buyAndSell_init.init_price = parseFloat(
                that.allMarketData[that.buyAndSell_init.symbol].c,
              );
            }
            //首次获取则获取交易对列表
            that.getSymbolList();
          } else {
            for (let key in retData.data) {
              //向allMarketData中更新或者添加交易对信息,理论上所有交易对都有，只需更新
              if (that.allMarketData.hasOwnProperty(key)) {
                that.allMarketData[key] = retData.data[key];
              } else {
                that.$set(that.allMarketData, key, retData.data[key]);
              }
            }
            that.getAllCoinMarket(that.originalSymbol); //重新整理拼接用于展示的交易对
            that.coinListChange(that.coinFilter.listIndex); //更新显示表格
            that.getFilterCoinTable(); //过滤交易对
          }

          const symbolData = that.allMarketData[that.buyAndSell_init.symbol];
          if (symbolData && symbolData.s) {
            const baseCoin = symbolData.s.split("/")[1];
            //如果不是USDT交易区，需要计算当前汇率
            if (baseCoin !== "USDT") {
              const key = baseCoin + "/USDT";
              const coinPrice =
                that.allMarketData[key] && that.allMarketData[key].c;
              if (coinPrice) {
                that.buyAndSell_init.rate = that.cnyRate * coinPrice;
              }
            }
          }
        }
      };
      Socket.onclose = function (e) {
        console.log("WebSocket关闭");
        //console.log(e)
      };
    },
    //获取用户资产
    getUserAsset() {
      this.$axios.post("/userAssets/queryAssetList", {}).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.userAssets = res.data.data;
          let that = this;
          //console.log(res.data.data)
          let coin_total_flag = true; //币资产标识
          let money_total = true; //可用金额标识
          this.userAssets.userAssetRsps.forEach((value, index) => {
            if (
              value.assetType.toUpperCase() ===
              this.buyAndSell_init.symbol.split("/")[0].toUpperCase()
            ) {
              coin_total_flag = false; //有可用币
              that.buyAndSell_init.coin_total = value.balanceAvailable;
            } else if (
              value.assetType.toUpperCase() ===
              this.buyAndSell_init.symbol.split("/")[1].toUpperCase()
            ) {
              money_total = false; //有可用金额
              that.buyAndSell_init.money_total = value.balanceAvailable;
            }
            if (coin_total_flag) {
              that.buyAndSell_init.coin_total = 0; //没有匹配到可用币
            }
            if (money_total) {
              that.buyAndSell_init.money_total = 0; //没有匹配到可用金额
            }
          });
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    //获取委托信息
    getDelegation(type) {
      this.tradeBoxType = type;
      if (this.user.username && window.localStorage.getItem("jwt-token")) {
        if (type === "current") {
          this.getCurrentDelegation();
        } else if (type === "history") {
          this.getHistoryDelegation();
        }
      }
    },
    //获取当前委托信息
    getCurrentDelegation() {
      this.$axios
        .post("/order/personal/current", this.currentFilter)
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            //console.log(res.data.data.list);
            this.current_delegation = res.data.data.list;
          }
        });
    },
    //获取历史委托信息
    getHistoryDelegation() {
      this.$axios
        .post("/order/personal/history", this.historyFilter)
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            //console.log(res.data.data.list)
            this.history_delegation = res.data.data.list;
          }
        });
    },
    //取消当前委托订单
    orderCancel(row) {
      this.$axios.post("/order/getTranToken", {}).then((res) => {
        this.$axios
          .post("/order/cancel", {
            token: res.data.data.token,
            orderId: row.orderId,
            symbol: row.symbol,
          })
          .then((res) => {
            if (res.data.code === this.errorCode.ok) {
              row.statusStr = "CANCELING";
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });
      });
    },
    //删除历史委托
    deleteHistory(row) {
      this.$axios
        .post("/order/delete", { orderId: row.orderId, symbol: row.symbol })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.$message({
              type: "success",
              message: this.$t("trade_ctc.delegationTable.delete_success"),
            });
            this.getHistoryDelegation();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
    getCoin() {
      return this.buyAndSell_init.symbol.split("/")[0];
    },
    getMoneyType() {
      return this.buyAndSell_init.symbol.split("/")[1].replace("T", "");
    },
    getLeftTime() {
      return this.getTimeRemaining(this.buyAndSell_init.countdown);
    },
  },
  watch: {
    "buyAndSell_init.symbol": function () {
      this.getPrecision();
    },
    pingTime() {
      if (this.pingTime >= 30) {
        this.socket.close();
        this.getWebsocket();
        this.pingTime = 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bj-w {
  background-color: #fff;
}
.ctc-wrap {
  width: 100%;
  background-color: #f5f6f7;
  .ctc-padding {
    padding-top: 20px;
    background-color: #f5f6f7;

    .trade-main {
      padding-bottom: 20px;
      min-width: 1180px;
      display: flex;

      .header {
        background: #ffffff;
        height: 40px;
      }

      .item-symbol {
        width: 330px;
        margin-left: 10px;
        position: relative;

        .change-coin-input {
          margin: 12px;
          width: calc(100% - 24px);
          /deep/ .el-input__inner {
            height: 45px;
            background: #ffffff;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #e2e3e3;
            padding: 12px;
            &::placeholder {
              color: #d6d8db;
            }
          }
          /deep/ .el-input__suffix {
            margin-right: 8px;
            pointer-events: auto;
            display: flex;
            align-items: center;
          }
        }

        .iconsousuo {
          font-size: 20px;
        }

        .search-header {
          display: flex;
          height: 40px;
          text-align: center;
          background: #ffffff;
          border-radius: 8px 8px 8px 8px;

          span {
            display: inline-block;
            height: 100%;
            line-height: 40px;
            font-family: PingFang SC, PingFang SC;
            color: #333333;
            flex: 1;
            cursor: pointer;
          }

          .choice-tab {
            color: var(--primary-color);
            position: relative;
            &::after {
              position: absolute;
              content: "";
              display: block;
              width: 36px;
              height: 1px;
              bottom: 0;
              left: 50%;
              background: var(--primary-color);
              transform: translateX(-50%);
            }
          }
        }

        .change-table {
          height: 784px;
          overflow: auto;
          .el-table tr td {
            cursor: pointer !important;
          }
          /deep/ .el-table__header-wrapper {
            border-bottom: 1px solid #e2e3e3;
          }
		  /deep/ .caret-wrapper {
			  width: auto !important;
		  }
        }
      }

      .item-l {
        width: 280px;
        margin-right: 10px;
        border-radius: 8px;
        .header {
          border-bottom: 1px solid #e2e3e3;
          span {
            position: relative;
            height: 100%;
            display: inline-block;
            width: 36px;
            line-height: 36px;
            text-align: center;
            cursor: pointer;
            img {
              width: 12px;
              height: 12px;
              vertical-align: middle;
            }
          }
        }

        .th {
          display: flex;
          height: 24px;
          padding: 0 10px;
          box-sizing: border-box;
          line-height: 24px;
          background: #ffffff;

          div {
            flex: 1;
            font-size: 12px;
            color: #55688b;
          }

          .volume-item {
            text-align: right;
          }

          .money-item {
            text-align: right;
          }
        }

        .show-window {
          height: 800px;
          overflow: hidden;
          position: relative;
          background: #ffffff;

          ul {
            width: 100%;

            li {
              width: 100%;
              display: flex;
              padding: 0 10px;
              box-sizing: border-box;
              height: 26px;
              line-height: 26px;
              font-size: 12px;

              div {
                flex: 1;

                &:first-of-type {
                  text-align: left;
                }

                &:nth-of-type(2) {
                  text-align: right;
                  color: #333333;
                }

                &:nth-of-type(3) {
                  text-align: right;
                  color: #333333;
                }
              }
            }
          }

          .sell-ul {
            position: absolute;
            bottom: 100%;
            left: 0;

            li {
              div {
                &:first-of-type {
                  color: #f04c66;
                }
              }
            }
          }

          .buy-ul {
            position: absolute;
            left: 0;
            top: 100%;

            li {
              div {
                &:first-of-type {
                  color: #3ec197;
                }
              }
            }
          }

          .all-wrap {
            width: 100%;
            height: 34px;
            line-height: 34px;
            color: #52c18e;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            text-align: center;
          }

          .buy-wrap {
            position: absolute;
            width: 100%;
            height: 100%;

            .buy-ul {
              top: 0;
            }
          }

          .sell-wrap {
            position: absolute;
            width: 100%;
            height: 100%;

            .sell-ul {
              bottom: unset;
              top: 0;
            }
          }
        }
      }

      .item-m {
        flex: 1;
        margin: 0;

        .market-header {
          margin: 0 10px;
          padding: 10px 10px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #333333;
          background: #ffffff;
          border-radius: 8px 8px 0 0;

          .header-items {
            display: flex;
          }

          .item {
            width: auto;
            margin-right: 50px;
            padding: 5px 0 5px;

            p {
              font-size: 12px;
              color: #55688b;
            }
          }

          .item-coin {
            margin: auto;
            margin-right: 40px;

            .coin-wrap {
              display: flex;
              align-items: center;

              img {
                margin-right: 10px;
              }

              .fullscreen-icon {
                display: inline-block;
                margin-left: 8px;
                cursor: pointer;
                opacity: 0.6;
                transition: opacity 0.2s;

                &:hover {
                  opacity: 1;
                }
              }
            }
          }
        }

        .kline-wrap {
          height: 550px;
          margin: 10px 10px;
          overflow: hidden;
          padding: 0 0px 2px 2px;
          background: #ffffff;
          border-radius: 8px 8px 8px 8px;
          position: relative;
          .not-start {
            position: absolute;
            color: #3ec197;
            font-size: 24px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .buy-sell-box-wrap {
          height: 358px;
          margin: 10px 10px;
          background: #fff;
          border-radius: 8px;

          .header {
            color: #333;
            height: 40px;
            box-sizing: border-box;
            padding: 0 30px;

            span {
              display: inline-block;
              height: 100%;
              line-height: 40px;
              cursor: pointer;
            }

            .choice {
              color: #52c18e;
              position: relative;
              //   &::after {
              //     content: "";
              //     width: 36px;
              //     height: 2px;
              //     position: absolute;
              //     background: #42cb83;
              //     bottom: 0;
              //     left: 50%;
              //     transform: translate(-50%);
              //   }
            }
          }

          .buy-box-wrap {
            padding: 10px 30px 10px;
            box-sizing: border-box;
          }
        }
      }

      .item-r {
        width: 280px;
        overflow: hidden;
        font-size: 12px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        margin-right: 10px;
        .header {
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-bottom: 1px solid #e2e3e3;
        }

        .table-header {
          box-sizing: border-box;
          height: 24px;
          line-height: 24px;
          padding: 0 10px;
          ul {
            li {
              text-align: right;

              &:first-of-type {
                width: 90px;
                text-align: left;
              }

              &:nth-of-type(2) {
                width: 80px;
              }

              &:nth-of-type(3) {
                width: 90px;
              }
            }
          }
        }

        .table-con {
          box-sizing: border-box;
          padding: 0 10px;
          height: 800px;
          overflow: hidden;

          ul {
            li {
              height: 24px;
              line-height: 24px;

              span {
                &:first-of-type {
                  color: #3ec197;
                }
                &:nth-of-type(2) {
                  color: #333333;
                }
                &:nth-of-type(3) {
                  width: 90px;
                  text-align: right;
                  color: #333333;
                }
              }

              .red {
                color: #f04c66 !important;
              }
            }
          }
        }
      }
    }

    .delegation-div {
      .delegation-title {
        height: 40px;
        min-width: 800px;
        line-height: 40px;
        padding: 0 170px;
        background: #262b3f;
        color: #a0aac1;
      }

      .delegation-wrap {
        .color-white {
          color: #333;
        }

        .cancel-btn {
          padding: 1px 11px;
          color: #55688b;
          border: 1px solid #55688b;
          border-radius: 2px;
          cursor: pointer;
        }
      }
    }
  }
}

@media screen and (max-width: 1750px) {
  .ctc-wrap .ctc-padding .trade-main .item-m .kline-wrap {
    height: 550px;
  }
}

@media screen and (max-width: 1600px) {
  .ctc-wrap .ctc-padding .trade-main .item-l .show-window {
    height: 600px;
  }

  .item-symbol .change-table {
    height: 584px !important;
  }

  .market-header {
    .item-coin {
      margin-right: 20px !important;
    }
    .item {
      margin-right: 20px !important;
    }
  }

  .ctc-wrap .ctc-padding .trade-main .item-m .kline-wrap {
    height: 550px;
  }

  .ctc-wrap .ctc-padding .trade-main .item-m .buy-sell-box-wrap {
    height: 338px;
  }

  /*.ctc-wrap .ctc-padding .trade-main .item-m .buy-sell-box-wrap .buy-box-wrap {*/
  /*    padding: 10px 10px 10px;*/

  /*}*/

  .ctc-wrap .ctc-padding .trade-main .item-r .table-con {
    height: 600px;
  }

  .el-table {
    font-size: 12px !important;
  }

  .el-table .cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  .ctc-wrap
    .ctc-padding
    .trade-main
    .item-r
    .table-header
    ul
    li:nth-of-type(3) {
    width: 80px;
  }

  .table-con ul li span:nth-of-type(3) {
    width: 80px !important;
  }
}
@media screen and (max-width: 1550px) {
  .item-r {
    display: none;
  }
}
@media screen and (max-width: 1440px) {
  .market-header {
    .item-coin {
      margin-right: 40px !important;
    }
    .item {
      margin-right: 35px !important;
    }
  }
  .ctc-wrap .ctc-padding .trade-main .item-l .show-window {
    height: 600px;
  }

  .ctc-wrap .ctc-padding .trade-main .item-m .kline-wrap {
    height: 550px;
  }

  .ctc-wrap .ctc-padding .trade-main .item-m .buy-sell-box-wrap {
    height: 338px;
  }

  .ctc-wrap .ctc-padding .trade-main .item-m .buy-sell-box-wrap .buy-box-wrap {
    padding: 10px 18px 10px;
  }

  .ctc-wrap .ctc-padding .trade-main .item-r .table-con {
    height: 600px;
  }

  .el-table {
    font-size: 12px !important;
  }

  .el-table .cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  .ctc-wrap
    .ctc-padding
    .trade-main
    .item-r
    .table-header
    ul
    li:nth-of-type(3) {
    width: 80px;
  }

  .table-con ul li span:nth-of-type(3) {
    width: 80px !important;
  }
}

@media screen and (max-width: 1360px) {
  .market-header {
    .item-coin {
      margin-right: 30px !important;
    }
    .item {
      margin-right: 25px !important;
    }
  }
  .ctc-wrap .ctc-padding .trade-main .item-m .kline-wrap {
    height: 550px;
  }
  .delegation-div {
    .delegation-title {
      padding: 0 60px;
    }

    .delegation-wrap {
      padding: 0 100px !important;
    }
  }
}

.fullscreen-kline-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  .fullscreen-header {
    padding: 20px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333;
    border-bottom: 1px solid #e0e0e0;
    .header-left {
      display: flex;
      align-items: center;
      .coin-wrap {
        display: flex;
        align-items: center;
        img {
          width: 32px;
          margin-right: 12px;
        }
        span {
          font-size: 20px;
          font-weight: bold;
        }
      }
      .market-info {
        margin-left: 40px;
        display: flex;
        gap: 40px;
        .info-item {
          p {
            font-size: 12px;
            color: #55688b;
            margin-bottom: 4px;
          }
          div {
            font-size: 16px;
            color: #333;
          }
        }
      }
    }
    .fullscreen-icon {
      cursor: pointer;
      svg path {
        fill: #55688b;
      }
    }
  }
  .fullscreen-chart {
    flex: 1;
    margin: 0;
    background: #fff;
    overflow: hidden;
  }
}

.symbol-drawer {
  .el-drawer__body {
    padding: 0;
    overflow: hidden;
    height: 100%;
  }
  .item-symbol {
    width: 330px;
    margin: 0;
    position: relative;
    height: 100%;

    .change-coin-input {
      margin: 12px;
      width: calc(100% - 24px);
      /deep/ .el-input__inner {
        height: 45px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e2e3e3;
        padding: 12px;
        &::placeholder {
          color: #d6d8db;
        }
      }
      /deep/ .el-input__suffix {
        margin-right: 8px;
        pointer-events: auto;
        display: flex;
        align-items: center;
      }
    }

    .iconsousuo {
      font-size: 20px;
    }

    .search-header {
      display: flex;
      height: 40px;
      text-align: center;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;

      span {
        display: inline-block;
        height: 100%;
        line-height: 40px;
        font-family: PingFang SC, PingFang SC;
        color: #333333;
        flex: 1;
        cursor: pointer;
      }

      .choice-tab {
        color: var(--primary-color);
        position: relative;
        &::after {
          position: absolute;
          content: "";
          display: block;
          width: 36px;
          height: 1px;
          bottom: 0;
          left: 50%;
          background: var(--primary-color);
          transform: translateX(-50%);
        }
      }
    }

    .change-table {
      height: 784px;
      overflow: auto;
      .el-table tr td {
        cursor: pointer !important;
      }
      /deep/ .el-table__header-wrapper {
        border-bottom: 1px solid #e2e3e3;
      }
      /deep/ .caret-wrapper {
        width: auto !important;
      }
    }
  }
}

.box-1 {
  margin: 12px;
  padding: 20px 60px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
}

.tab-box {
  gap: 40px;
  display: flex;
  border-bottom: 1px solid #e2e3e3;
  div {
    padding-bottom: 12px;
    cursor: pointer;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
  }
  .sel {
    font-size: 16px;
    position: relative;
  }
  .sel::before {
    content: "";
    position: absolute;
    display: block;
    left: 0;
    width: 100%;
    bottom: 0;
    border-bottom: 1px solid var(--primary-color);
  }
}
.table-li1 {
  display: inline-block;
  width: 90px;
}
.table-li2 {
  display: inline-block;
  width: 80px;
  text-align: right;
}
.table-li3 {
  display: inline-block;
  width: 90px;
  text-align: right;
}
.tab-head {
  height: 40px;
  gap: 40px;
  line-height: 40px;
  display: flex;
  background: #ffffff;
  margin: 10px 10px;
  border-radius: 8px 8px 8px 8px;
  padding-left: 40px;
  div {
    padding-bottom: 22px;
    cursor: pointer;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
  }
  .sel {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 12px;
    color: var(--primary-color);
    position: relative;
  }
  .sel::before {
    content: "";
    position: absolute;
    display: block;
    left: 0;
    width: 100%;
    bottom: 0;
    border-bottom: 2px solid var(--primary-color);
  }
}
</style>
